/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type EventTeam_eventParent = {
    readonly id: string;
    readonly externalEventId: string;
    readonly events: ReadonlyArray<{
        readonly calendarIds: ReadonlyArray<string>;
        readonly isAllDay: boolean | null;
        readonly isClockwiseEvent: boolean;
        readonly locked: boolean | null;
        readonly organizerPerson: {
            readonly emails?: ReadonlyArray<string> | undefined;
        } | null;
        readonly annotatedEvent: {
            readonly userTags: ReadonlyArray<{
                readonly tag: string;
                readonly states: ReadonlyArray<{
                    readonly value: string | null;
                    readonly subjectType: SubjectUrnTypeEnum;
                    readonly subjectValue: string;
                    readonly lastModified: number;
                    readonly active: boolean;
                }> | null;
            }> | null;
            readonly orgTags: ReadonlyArray<{
                readonly tag: string;
                readonly state: {
                    readonly subjectType: SubjectUrnTypeEnum;
                    readonly subjectValue: string;
                    readonly value: string | null;
                    readonly active: boolean;
                };
            }> | null;
        } | null;
        readonly eventKey: {
            readonly id: string;
            readonly calendarIds: ReadonlyArray<string> | null;
            readonly externalEventId: string;
            readonly hashedCalendars: string | null;
            readonly orgId: string | null;
        };
        readonly startTime: {
            readonly millis: number;
            readonly dateOrDateTime: string;
            readonly timeZone: string | null;
        };
        readonly endTime: {
            readonly millis: number;
        };
        readonly title: string | null;
        readonly attendees: ReadonlyArray<{
            readonly displayName: string | null;
            readonly urnValue: string;
        }>;
        readonly organizer: {
            readonly urnValue: string;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"AutopilotFormSaveOnEdit_event" | "EventSummary_event" | "EventSmartHoldInfo_event" | "EventPeople_event" | "EventSummaryTime_event">;
    }>;
    readonly " $refType": "EventTeam_eventParent";
};
export type EventTeam_eventParent$data = EventTeam_eventParent;
export type EventTeam_eventParent$key = {
    readonly " $data"?: EventTeam_eventParent$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventTeam_eventParent">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarIds",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectType",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectValue",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v10 = [
        {
            "kind": "Variable",
            "name": "calendarId",
            "variableName": "calendarId"
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "calendarId"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "EventTeam_eventParent",
        "selections": [
            (v0 /*: any*/),
            (v1 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "events",
                "plural": true,
                "selections": [
                    (v2 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAllDay",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isClockwiseEvent",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locked",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "organizerPerson",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emails",
                                        "storageKey": null
                                    }
                                ],
                                "type": "Person",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnnotatedEvent",
                        "kind": "LinkedField",
                        "name": "annotatedEvent",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserTag",
                                "kind": "LinkedField",
                                "name": "userTags",
                                "plural": true,
                                "selections": [
                                    (v3 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TagState",
                                        "kind": "LinkedField",
                                        "name": "states",
                                        "plural": true,
                                        "selections": [
                                            (v4 /*: any*/),
                                            (v5 /*: any*/),
                                            (v6 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "lastModified",
                                                "storageKey": null
                                            },
                                            (v7 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgTag",
                                "kind": "LinkedField",
                                "name": "orgTags",
                                "plural": true,
                                "selections": [
                                    (v3 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TagState",
                                        "kind": "LinkedField",
                                        "name": "state",
                                        "plural": false,
                                        "selections": [
                                            (v5 /*: any*/),
                                            (v6 /*: any*/),
                                            (v4 /*: any*/),
                                            (v7 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventKey",
                        "kind": "LinkedField",
                        "name": "eventKey",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v2 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hashedCalendars",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "orgId",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "startTime",
                        "plural": false,
                        "selections": [
                            (v8 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dateOrDateTime",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeZone",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "endTime",
                        "plural": false,
                        "selections": [
                            (v8 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Attendee",
                        "kind": "LinkedField",
                        "name": "attendees",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                            },
                            (v9 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Attendee",
                        "kind": "LinkedField",
                        "name": "organizer",
                        "plural": false,
                        "selections": [
                            (v9 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "args": (v10 /*: any*/),
                        "kind": "FragmentSpread",
                        "name": "AutopilotFormSaveOnEdit_event"
                    },
                    {
                        "args": (v10 /*: any*/),
                        "kind": "FragmentSpread",
                        "name": "EventSummary_event"
                    },
                    {
                        "args": (v10 /*: any*/),
                        "kind": "FragmentSpread",
                        "name": "EventSmartHoldInfo_event"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventPeople_event"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventSummaryTime_event"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "EventParent",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'e1b96758f3f6edc4dcdbb01ca146fc09';
export default node;
